/* Thryve homepage: buy box option switching, gallery thumbs,
   mobile sticky add-to-cart, and tap-to-play review videos. */
(function () {
  if (window.__thryveHome) return;
  window.__thryveHome = true;

  function initBuy(root) {
    var form = root.querySelector('[data-th-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var opts = root.querySelectorAll('[data-th-option]');

    function select(btn) {
      opts.forEach(function (o) {
        var on = o === btn;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      idInput.value = btn.dataset.variant;
      document.querySelectorAll('[data-th-price]').forEach(function (el) { el.textContent = btn.dataset.price; });
      document.querySelectorAll('[data-th-compare]').forEach(function (el) {
        el.textContent = btn.dataset.compare || '';
        el.hidden = !btn.dataset.compare;
      });
      document.querySelectorAll('[data-th-label]').forEach(function (el) { el.textContent = btn.dataset.label; });
      var available = btn.dataset.available === 'true';
      document.querySelectorAll('[data-th-submit]').forEach(function (s) {
        s.disabled = !available;
        var t = s.querySelector('[data-th-submit-text]');
        if (t) t.textContent = available ? s.dataset.label : 'Sold out';
      });
    }

    opts.forEach(function (o) { o.addEventListener('click', function () { select(o); }); });
    var active = root.querySelector('[data-th-option].is-active');
    if (active) select(active);

    // gallery thumbnails
    var main = root.querySelector('[data-th-main]');
    var thumbs = root.querySelectorAll('[data-th-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) main.src = t.dataset.src;
        thumbs.forEach(function (x) {
          var on = x === t;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-current', on ? 'true' : 'false');
        });
      });
    });

    // hide the mobile sticky bar while the real buy box is on screen
    var sticky = document.querySelector('[data-th-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { sticky.classList.toggle('is-hidden', e.isIntersecting); });
      }, { threshold: 0.1 }).observe(form);
    }
  }

  function initReviews(root) {
    var row = root.querySelector('.th-reviews__row');
    var track = root.querySelector('.th-reviews__track');
    var anyPlaying = false;
    var onPlayingChange = function () {};

    root.querySelectorAll('[data-th-review]').forEach(function (card) {
      var video = card.querySelector('video');
      var play = card.querySelector('[data-th-play]');
      if (!video || !play) return;
      play.addEventListener('click', function () {
        document.querySelectorAll('[data-th-review] video').forEach(function (other) {
          if (other !== video) other.pause();
        });
        video.muted = false;
        video.play();
      });
      video.addEventListener('click', function () { if (!video.paused) video.pause(); });
      video.addEventListener('play', function () { card.classList.add('is-playing'); anyPlaying = true; onPlayingChange(); });
      video.addEventListener('pause', function () { card.classList.remove('is-playing'); anyPlaying = false; onPlayingChange(); });
    });

    if (!row || !track) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
      /* mobile: native scrollLeft nudge, same position the user's own swipe uses —
         one position system, nothing to fight with manual touch. */
      var dir = 1;
      var paused = false;
      var resumeTimer = null;
      var expected = row.scrollLeft;

      function scheduleResume() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 3000);
      }

      row.addEventListener('scroll', function () {
        if (Math.abs(row.scrollLeft - expected) < 2) return; /* our own nudge settling, not the user */
        scheduleResume();
      }, { passive: true });

      function nudge() {
        if (paused || anyPlaying) return;
        var max = row.scrollWidth - row.clientWidth;
        if (max <= 1) return;
        var step = Math.max(row.clientWidth * 0.5, 180);
        var target = row.scrollLeft + dir * step;
        if (target >= max) { target = max; dir = -1; }
        else if (target <= 0) { target = 0; dir = 1; }
        expected = target;
        row.scrollTo({ left: target, behavior: 'smooth' });
      }

      setInterval(nudge, 2000);
    } else {
      /* desktop: continuous CSS-driven bounce on the inner track, row just clips.
         No native scroll here, so nothing can fight the animation. */
      var SPEED = 60;
      onPlayingChange = function () {
        track.style.animationPlayState = anyPlaying ? 'paused' : 'running';
      };

      function setBounceDistance() {
        var max = Math.max(track.scrollWidth - row.clientWidth, 0);
        track.style.setProperty('--th-bounce', max + 'px');
        track.style.setProperty('--th-bounce-duration', Math.max(max / SPEED, 3) + 's');
        track.classList.toggle('th-reviews__track--auto', max > 1);
      }

      setBounceDistance();
      window.addEventListener('resize', setBounceDistance);
    }
  }

  function init() {
    document.querySelectorAll('[data-th-buy]').forEach(initBuy);
    document.querySelectorAll('[data-th-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
